exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Video {\n  -webkit-user-drag: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none; }\n  .Video--hasBorder {\n    border: 5px solid #F57C00; }\n  .Video--loading {\n    display: none; }\n", ""]);

